<script lang="ts">
  import { NavigateOptions } from '@/types';
  import { Context } from 'page';
  import qs from 'query-string';
  import { onDestroy, setContext } from 'svelte';
  import Route from './Route.svelte';
  import { component, context, layout, router } from './routerEntities';

  const localNavigate = (opts: NavigateOptions = {}) => {
    const { path, params } = opts;
    const query = qs.stringify(
      {
        ...$context.query,
        ...params,
      },
      { arrayFormat: 'comma' },
    );
    let newPath: string = $context.pathname;
    if (path) {
      newPath = path.startsWith('/') ? path : `${$context.pathname}/${path}`;
    }
    if (query) {
      newPath += '?' + query;
    }
    router.show(newPath);
  };

  setContext('context', context);
  setContext('router', {
    localNavigate,
    navigate: router.show,
  });

  const unsub = router.route.subscribe((v) => {
    if (v.component) {
      component.set(v.component);
    }
    if (v.layout) {
      layout.set(v.layout);
    }
    context.set(v.context || <Context>{});
  });
  onDestroy(unsub);
</script>

<Route component={$component} layout={$layout} context={$context} navigate={router.show} />
